import { FormulaEquation } from '../../types';
import { KINEMATICS_EQUATIONS } from './kinematics';
import { DYNAMICS_EQUATIONS } from './dynamics';
import { THERMO_ELECTRO_EQUATIONS } from './thermoElectro';
import { MATH_EQUATIONS } from './mathEquations';

export * from './variables';
export * from './kinematics';
export * from './dynamics';
export * from './thermoElectro';
export * from './mathEquations';

export const FORMULA_EQUATIONS: FormulaEquation[] = [
  ...KINEMATICS_EQUATIONS,
  ...DYNAMICS_EQUATIONS,
  ...THERMO_ELECTRO_EQUATIONS,
  ...MATH_EQUATIONS,
];

export const EQUATION_BY_ID: Record<string, FormulaEquation> = Object.fromEntries(
  FORMULA_EQUATIONS.map((eq) => [eq.id, eq])
);
